import { Card } from "antd";

export default function ECard({ title, extra, isLoading, props, children }) {
  return (
    <Card title={title} extra={extra} bordered={false} loading={isLoading} {...props}>
      {children}
    </Card>
  );
}
